import axios from "axios";
import store from "../../../../../stores/application/index.js.erb";

const get_token = () => {
    const token = document.querySelector('[name=csrf-token]').content;
    return axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
}

const StudyEstimationEukApiService = {
    async index() {
        get_token();
        try {
            return await axios.get('/study/study_api_estimation_euk');
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async get_async_current_course(params) {
        get_token();
        try {
            return await axios.put(
                '/study/study_api_estimation_euk/get_async_current_course',
                { content_sync: params }
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
}

export default StudyEstimationEukApiService;